import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setFaqOpen(faqOpen === idx ? null : idx);
  };

  const faqs = [
    {
      q: '吃瓜爆料是一个什么样的平台？',
      a: '吃瓜爆料是一个专业的网络热点爆料聚合平台，致力于为吃瓜群众提供最新、最全、最热的爆料内容。我们覆盖明星爆料、网红黑料、社会热点、娱乐圈内幕、电竞圈动态等多个领域，每日更新，让您不错过任何一个瓜。',
    },
    {
      q: '平台上的爆料内容是否真实可靠？',
      a: '我们秉持客观公正的原则，所有爆料内容均来自公开渠道和多方信源核实。我们会标注信息来源，并欢迎用户对不实内容进行举报。对于未经证实的传闻，我们会明确标注"传闻"或"待核实"标签，帮助读者理性辨别。',
    },
    {
      q: '每天会更新多少条爆料内容？',
      a: '我们的编辑团队7x24小时关注网络热点，确保每天至少更新30条以上的高质量爆料内容。在热点事件爆发时，我们会实时跟进，第一时间为您带来最新进展。',
    },
    {
      q: '如何向我们投稿爆料线索？',
      a: '您可以通过下方的联系方式或电子邮箱向我们提供爆料线索。我们严格保护爆料人的隐私信息，绝不泄露任何来源。如果您的爆料被采纳，我们会给予相应的奖励。',
    },
    {
      q: '为什么有些内容看不到了？',
      a: '根据相关法律法规和平台内容规范，部分内容可能因涉及隐私、侵权或其他合规原因被下架处理。我们致力于在合法合规的前提下，为大家提供优质的爆料内容。',
    },
  ];

  return (
    <>
      <title>关于我们 - 吃瓜爆料</title>
      <meta name="description" content="吃瓜爆料品牌介绍、口碑评价和联系方式。汇集全网最热的吃瓜爆料内容，每日更新明星黑料、网红翻车、社会热点。" />
      <meta name="keywords" content="吃瓜爆料,关于我们,品牌介绍,口碑,联系方式" />

      {/* Breadcrumb */}
      <div className="bg-background-100 border-b border-secondary-200/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-3">
          <nav className="flex items-center gap-2 text-sm" aria-label="面包屑导航">
            <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
              首页
            </Link>
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            <span className="text-foreground-900 font-medium">关于我们</span>
          </nav>
        </div>
      </div>

      {/* Hero */}
      <section className="bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-16 text-center">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            关于吃瓜爆料
          </h1>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto leading-relaxed">
            吃瓜爆料成立于2024年，是国内领先的网络热点爆料聚合平台。我们秉持"让每一个瓜都被看到"的理念，
            致力于为亿万吃瓜群众提供最新鲜、最全面、最真实的爆料内容。
          </p>
        </div>
      </section>

      {/* Brand story */}
      <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col md:flex-row gap-10 items-center">
          <div className="flex-1">
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-4">品牌故事</h2>
            <div className="text-foreground-700 leading-relaxed space-y-4">
              <p>
                在信息爆炸的时代，每天都有无数的热点事件在网络上发生和消失。吃瓜群众们常常面临"瓜太多吃不过来"或"吃到了假瓜"的困境。
                正是看到了这一痛点，吃瓜爆料应运而生。
              </p>
              <p>
                我们的创始团队来自知名互联网公司和传统媒体，拥有丰富的热点追踪和内容审核经验。
                我们建立了完善的爆料采集、核实和分发体系，确保每一条呈现在读者面前的爆料都经过了严格的筛选和验证。
              </p>
              <p>
                截至目前，吃瓜爆料已累计发布超过10万条爆料内容，服务超过500万忠实用户。
                我们的内容被多家主流媒体引用，成为网络热点传播的重要节点。
              </p>
            </div>
          </div>
          <div className="w-full md:w-[400px] shrink-0">
            <div className="w-full h-[300px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20screens%20showing%20breaking%20news%2C%20editorial%20team%20collaborating%2C%20warm%20ambient%20lighting%2C%20professional%20journalism%20atmosphere%2C%20clean%20minimalist%20design%2C%20soft%20focus%20background%2C%20documentary%20style&width=800&height=600&seq=about-brand&orientation=landscape"
                alt="吃瓜爆料品牌故事"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { value: '500万+', label: '忠实用户' },
              { value: '10万+', label: '累计爆料' },
              { value: '30条+', label: '每日更新' },
              { value: '99.7%', label: '用户满意度' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">{stat.value}</div>
                <div className="text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reputation */}
      <section id="reputation" className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">口碑评价</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              quote: '"吃瓜爆料是我每天必刷的平台，更新快、内容全，再也不用担心错过什么大瓜了。"',
              author: '资深吃瓜群众小王',
              role: '忠实用户 3年',
            },
            {
              quote: '"作为自媒体人，吃瓜爆料是我获取选题灵感的重要来源，信息核实也很到位，值得信赖。"',
              author: '自媒体博主李老师',
              role: '内容创作者',
            },
            {
              quote: '"页面干净、没有乱七八糟的广告，浏览体验很好。推送也很及时，热点事件第一时间就能看到。"',
              author: '互联网打工人小张',
              role: '日活用户',
            },
          ].map((review, idx) => (
            <div key={idx} className="bg-background-100 rounded-lg p-6 flex flex-col">
              <div className="flex gap-1 mb-4 text-accent-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-foreground-700 leading-relaxed flex-1 mb-4">{review.quote}</p>
              <div className="border-t border-secondary-200/60 pt-4">
                <p className="text-foreground-900 font-medium text-sm">{review.author}</p>
                <p className="text-foreground-400 text-xs">{review.role}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
          <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">常见问题</h2>
          <div className="max-w-3xl mx-auto flex flex-col gap-3">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-background-50 rounded-lg border border-secondary-200/60 overflow-hidden">
                <button
                  onClick={() => toggleFaq(idx)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-secondary-50 transition-colors"
                >
                  <span className="text-foreground-900 font-medium pr-4">{faq.q}</span>
                                    {faqOpen === idx ? (
                    <i className="ri-arrow-up-s-line text-foreground-400 text-lg shrink-0"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-foreground-400 text-lg shrink-0"></i>
                  )}
                </button>
                {faqOpen === idx && (
                  <div className="px-5 pb-5 text-foreground-600 text-sm leading-relaxed animate-fadeInUp">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">联系我们</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl mx-auto">
          <div>
            <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-4">联系方式</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                <div>
                  <p className="text-foreground-500 text-xs">电子邮箱</p>
                  <p className="text-foreground-900 text-sm">tips@chigua-news.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                  <i className="ri-phone-line"></i>
                </div>
                <div>
                  <p className="text-foreground-500 text-xs">商务合作</p>
                  <p className="text-foreground-900 text-sm">business@chigua-news.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-200 text-secondary-700 shrink-0">
                  <i className="ri-map-pin-line"></i>
                </div>
                <div>
                  <p className="text-foreground-500 text-xs">办公地址</p>
                  <p className="text-foreground-900 text-sm">中国北京市朝阳区望京科技园A座12层</p>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-4">订阅每日爆料</h3>
            <p className="text-sm text-foreground-600 mb-4">
              订阅我们的每日爆料推送，每天早上第一时间获取最新吃瓜内容。
            </p>
            <form
              action="https://readdy.ai/api/form/d9oqu42ftmtnfcfh0ci0"
              method="POST"
              data-readdy-form="true"
              className="flex flex-col sm:flex-row gap-3"
            >
              <input
                type="email"
                name="email"
                placeholder="请输入您的邮箱地址"
                required
                className="flex-1 px-4 py-2.5 rounded-lg border border-secondary-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                className="px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                立即订阅
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Schema.org */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "吃瓜爆料",
          "url": "https://chigua.vercel.app",
          "description": "吃瓜爆料是国内领先的网络热点爆料聚合平台。",
          "email": "tips@chigua-news.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "北京",
            "addressRegion": "朝阳区",
            "streetAddress": "望京科技园A座12层",
            "addressCountry": "CN"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "email": "tips@chigua-news.com"
          }
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "吃瓜爆料",
          "url": "https://chigua.vercel.app",
          "description": "吃瓜爆料黑料聚合页，汇集吃瓜爆料黑料网、吃瓜爆料视频、吃瓜爆料每日大赛等热门爆料内容。"
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map((faq) => ({
            "@type": "Question",
            "name": faq.q,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.a
            }
          }))
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "首页",
              "item": "https://chigua.vercel.app/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "关于我们"
            }
          ]
        })}
      </script>
    </>
  );
}